import { React, useState } from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import CancelIcon from "@mui/icons-material/Cancel";
import Image from "../../../../images/otpModal.png";
import { InputAdornment, TextField } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { setAuthToken } from "../../../../utils/setAuthToken";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ForgotPassModal from "./passModalFP";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: 525,
  width: "100%",
  "@media(max-width:600px)": { width: "303px!important" },
  minWidth: "303px!important",
  bgcolor: "#FFFFFF",
  borderRadius: "24px",
  boxShadow: 24,
  p: "1rem 1.4rem ",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

export default function ForgotEnterOtpModal(props) {
  //Normal use states
 
  const [otp, setOtp] = useState("");
  const email=props.email
  const navigate = useNavigate();
  // Modal use State
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const forgotPasswordOtp = (e) => {
    console.log(email);
    console.log(localStorage.getItem("tempToken"));
    e.preventDefault();
    setAuthToken(localStorage.getItem("tempToken"));
    axios
      .post("https://api.blockpay.co.za/forgotpassword/forgotPasswordOtp", {
        email: email,
      })
      .then((res) => {
        toast.success(res.data.message);
        console.log(res);
      })
      .catch((err) => {
        toast.error(err.response.data.message);
        if (err.response.data.message == "Unauthorized!") {
          localStorage.clear();
          navigate("/signinpin", { replace: true });
        }
        console.log(err);
      });
  };

  const verifyOTP = (e) => {
    console.log("haha");
    e.preventDefault();
    setAuthToken(localStorage.getItem("tempToken"));
    axios
      .post("https://api.blockpay.co.za/forgotpassword/forgotPasswordVerify", {
        email: email,
        otp: otp,
      })
      .then((res) => {
        toast.success(res.data.message);
        console.log(res);
        handleOpen();
      })
      .catch((err) => {
        toast.error(err.response.data.message);
        if (err.response.data.message == "Unauthorized!") {
          localStorage.clear();
          navigate("/signinpin", { replace: true });
        }
        console.log(err);
      });
  };
  return (
    <div>
      <ToastContainer />
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        {...props}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={props.open}>
          <Box sx={style}>
            <Box
              sx={{
                color: "#919191",
                marginLeft: "auto",
              }}
              onClick={props.onClose}
            >
              <CancelIcon />
            </Box>
            <Box
              component="img"
              src={Image}
              sx={{ height: "200px", width: "230px" }}
            />
            <Typography
              id="transition-modal-title"
              variant="h5"
              component="h2"
              sx={{ fontWeight: "500", lineHeight: "2.421rem" }}
            >
              Forgot Password ?
            </Typography>
            <Typography
              id="transition-modal-description"
              sx={{
                mt: 1,
                mb: 2,
                fontSize: "16px!important",
                color: "#626262",
                textAlign: "center",
              }}
            >
              Enter your OTP !!
            </Typography>

            <TextField
              id="otp"
              className="logintextField"
              label="Enter OTP"
              InputLabelProps={{ shrink: true }}
              variant="outlined"
              type="text"
              onChange={(e) => setOtp(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Typography
                      sx={{
                        color: "#0582FF",
                        fontWeight: "500",
                        fontSize: "0.875rem",
                        textTransform: "none",
                      }}
                      onClick={forgotPasswordOtp}
                      component={Button}
                    >
                      Resend OTP
                    </Typography>
                  </InputAdornment>
                ),
              }}
              required
            />

            <Button
              className="loginButtonSignUp"
              variant="contained"
              color="primary"
              size="large"
              type="submit"
              onClick={verifyOTP}
              disabled={email === "" || !otp}
              sx={{ textTransform: "none", borderRadius: "10px", mb: "1rem" }}
            >
              <span className="buttonSignText">Verify OTP</span>
            </Button>
          </Box>
        </Fade>
      </Modal>
      <ForgotPassModal open={open} onClose={handleClose} email={email} />
    </div>
  );
}
